import { render, staticRenderFns } from "./EditResponsiblePerson.vue?vue&type=template&id=5786fc53&scoped=true"
import script from "./EditResponsiblePerson.vue?vue&type=script&lang=js"
export * from "./EditResponsiblePerson.vue?vue&type=script&lang=js"
import style0 from "./EditResponsiblePerson.vue?vue&type=style&index=0&id=5786fc53&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5786fc53",
  null
  
)

export default component.exports